/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
/* eslint-disable eslint-comments/no-restricted-disable */

import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { JiraNavigationSettingsAri } from '@atlassian/ari/jira/navigation-settings';
import { IdentityUserAri } from '@atlassian/ari/identity/user';
import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import { NavigationSettingAri } from '@atlassian/ari/navigation/setting';
import type { Nav4FiltersContentViewQueryEntrypointProps } from './Nav4FiltersContentViewQuery.entrypoint.types.tsx';
import parameters, {
	type Nav4FiltersContentViewQuery,
} from './__generated__/Nav4FiltersContentViewQuery.graphql';
import type { EntryPointParams } from './Nav4FiltersContentViewQuery.tsx';

type Queries = { queryRef: Nav4FiltersContentViewQuery };

type AsyncFiltersContentViewQueryComponent = EntryPointComponent<
	Queries,
	{},
	Nav4FiltersContentViewQueryEntrypointProps,
	{}
>;

export const asyncFiltersContentViewQuery: EntryPoint<
	AsyncFiltersContentViewQueryComponent,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForUserVisible<AsyncFiltersContentViewQueryComponent>(
		/* webpackChunkName: "async-nav4-filters-content-view-query" */ './Nav4FiltersContentViewQuery.tsx',
		{
			includeInShellOnlySsrBundle: true,
			entryFsSsrLiftImportToModule: true,
		},
	),

	getPreloadProps: (params: EntryPointParams) => {
		const cloudId = params.cloudId;

		const entityAriFilters = fg('navx-3660-fix-l2-l3-aris')
			? NavigationSettingAri.create({
					activationId: params.activationId || '',
					firstPartyApp: 'jira',
					settingId: 'filters',
					siteId: cloudId,
				}).toString()
			: JiraNavigationSettingsAri.create({
					siteId: cloudId,
					activationId: params.activationId || '',
					navigationSettingScope: 'filters',
				}).toString();

		const variables = expVal('navx-2365-add_dnd_to_jira_l2_menu_items', 'isEnabled', false)
			? {
					cloudId,
					currentURL: params.currentURL,
					ownerAri: IdentityUserAri.create({
						userId: params.accountId || 'UNKNOWN',
					}).toString(),
					entityAriFilters,
					skipOrderQuery: false,
				}
			: {
					cloudId,
					currentURL: params.currentURL,
					entityAriFilters: '',
					ownerAri: '',
					skipOrderQuery: true,
				};

		return {
			queries: {
				queryRef: {
					parameters,
					variables,
				},
			},
		};
	},
});
